import { api } from '@/api/axios.config'
import { Excursion } from '@/core/interface/Excursion'
export const getExcursions = async (): Promise<Excursion[] | undefined> => {
  try {
    const { data } = await api.get<Excursion[]>('en/excursions.json')
    return data
  } catch (e) {
    console.error('Landmarks Error', e)
  }
}
